import React, { Component } from "react"
import "../assets/css/success.css"
import { Link } from 'gatsby';
import closeChat from "../images/close-icon.svg"
import booklense from "../images/booklense.svg"

class Popup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: false,
            linkText:this.props.linkText,
            popupMessage:this.props.popupMessage,
            popupHead:this.props.popupHead,
            btnLabel:this.props.btnLabel
        };
        //console.log('--constructor--')
    }
    
    render() {
        const { popupMessage,popupHead, btnLabel, showPopup, linkText} = this.state;
        return (
            <span className="mypopup">
            <a onClick={() => this.setState({ showPopup: true })} dangerouslySetInnerHTML={{__html: linkText}}></a>
            
            {showPopup ?
                <div className="success-container how">
                    <div className="success-inner small">
                        <div  className="close-btn close">
                            <img alt="close" className="" src={closeChat} onClick={() => this.setState({ showPopup: false })} />
                        </div>
                        <div className="content">
                        <h2 className="head">{popupHead}</h2>
                        <div className="howpop-left"><img src={booklense} alt="Info" /></div>
                        <div className="howpop-right"><div className="how-text" dangerouslySetInnerHTML={{__html: popupMessage}}></div></div>
                        
                        
                        <br />
                            
                        <div className="howpop-btn">
                            {btnLabel==='Contact Us'?
                                <Link to="/contact/" className="btn primary get-price">Contact Us</Link>
                                :
                                <button className="btn" onClick={() => this.setState({ showPopup: false })} >{btnLabel}</button>
                            }
                        </div>
                        </div>
                    </div>
                </div>
                :''}
            </span>
        );
    }
}



export default Popup;
